import React from 'react';
import type { FaqItem } from './faqs';
export const faqsContact: FaqItem[] = [{
  q: 'What do you need from me to run this?',
  a: <>
        A sentence describing the workflow, and the kind of rules it has to honor. No integration, no data dump — we
        can show the mechanism on a representative request first.
      </>
}, {
  q: 'Do you touch or retain our data?',
  a: <>
        Not to show you the mechanism. The initial walkthrough runs on a representative example, not your production
        data. Anything beyond that is scoped and agreed in writing first.
      </>
}, {
  q: 'Who sees this? Is it under NDA?',
  a: <>
        Only our team, and we'll sign an NDA before you share anything sensitive. Just ask in the note.
      </>
}, {
  q: 'How long does the walkthrough take?',
  a: <>
        Thirty minutes. Enough to see a governed payload and its receipt, and to decide whether it's worth a deeper
        look.
      </>
}, {
  q: "What if we're not in a regulated industry?",
  a: <>
        Then you may not need us — and we'll tell you. Synthia earns its keep where a wrong answer is expensive and
        someone can be asked to prove it didn't happen. No regulator required, but the consequence has to be real.
      </>
}];